import { Component, OnInit } from '@angular/core'
import { CategoryTreeType } from '../../models'
import { CoreService } from '../../services'

@Component({
  selector: 'categories',
  templateUrl: 'categories.component.html',
})
export class CategoriesComponent implements OnInit {
  public categoryTreeTypeEnum = CategoryTreeType
  public canCreate: boolean

  constructor(private core: CoreService) {}

  ngOnInit(): void {
    if (this.core.services.user.user) {
      this.checkPerms()
    }
    this.core.services.user.currentUserEmitter.subscribe().then(() => {
      this.checkPerms()
    })
  }

  checkPerms(): boolean {
    this.canCreate =
      this.core.services.user.hasRole('ROLE_CATEGORY_CREATE') || this.core.services.user.hasRole('ROLE_SUPER_ADMIN')
    return this.canCreate
  }
}
